<template>
  <div :class="{ 'add-select': add }">
    <el-select
      v-model="selected"
      size="small"
      filterable
      remote
      clearable
      @change="handleChange"
      :remote-method="requestOptions"
      :loading="loading"
      placeholder="搜索并选择"
      :popper-append-to-body="false"
      :class="{ long: !add }"
      style="width: 100%"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name + '（' + item.mobile + '）'"
        :value="item.id"
      ></el-option>
    </el-select>

    <el-button
      v-if="add"
      type="primary"
      plain
      class="ml-10"
      size="small"
      icon="el-icon-plus"
      @click="addNewOption"
      >新建</el-button
    >
    <NewFormer
      :model="newModel"
      :show.sync="addFormVisible"
      @created="createdCallback"
      :inner="true"
    ></NewFormer>
  </div>
</template>

<script>
import { customerContactList } from '../../service/getData'
import NewFormer from '@/components/customer_contact'

export default {
  components: {
    NewFormer,
  },
  props: {
    val: '',
    customerID: 0,
    add: false,
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      } else if (this.options.length == 0) {
        this.requestDefaultOption()
      }
    },
    customerID: function (v) {
      this.newModel.customer_id = v || 0
      if (v) {
        this.requestOptions('all')
      }
    },
  },
  data() {
    return {
      selected: '',
      options: [],
      loading: false,
      addFormVisible: false,
      newModel: {
        customer_id: this.customerID,
        name: '',
        mobile: '',
        duty: '',
        email: '',
      },
    }
  },
  created() {
    if (this.val > 0) {
      this.requestDefaultOption()
    } else if (this.customerID > 0) {
      this.requestOptions('all')
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    handleChange() {
      this.$emit('change', parseInt(this.selected) || 0)
    },
    createdCallback(res) {
      this.options.push(res)
      this.selected = res.id
      this.$emit('change', parseInt(this.selected) || 0)
    },
    addNewOption() {
      if (!this.customerID) {
        this.$alert('请先选择客户')
        return
      }
      this.addFormVisible = true
    },
    async requestDefaultOption() {
      let res = await customerContactList({
        id: this.val,
        customer_id: this.customerID || 0,
      })
      this.options = res.data.list
      this.selected = this.val
    },
    async requestOptions(query) {
      if (query !== '') {
        this.loading = true
        query = query == 'all' ? '' : query
        let data = {
          query: query,
          customer_id: this.customerID || 0,
        }
        let res = await customerContactList(data)
        this.loading = false
        this.options = res.data.list
      } else {
        this.options = []
      }
    },
  },
}
</script>